var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"sp-container",style:(("background-color: " + (_vm.slider.color) + ";")),attrs:{"fluid":""}},[_c('div',{staticClass:"progressbar-container"},[_c('div',{class:['progressbar', _vm.slider.animations.progress]})]),(_vm.$vuetify.breakpoint.smAndDown)?[_c('div',{staticClass:"control-for-sm control-for-sm-left"},[_c('v-btn',{class:[
					'white--text',
					'elevation-0',
					'animate__animated',
					_vm.slider.animations.control_left ],attrs:{"fab":"","color":"transparent"},on:{"click":function($event){return _vm.sliderChange(_vm.Prev)}}},[_c('v-icon',[_vm._v(" mdi-chevron-double-left ")])],1)],1),_c('div',{staticClass:"control-for-sm control-for-sm-right"},[_c('v-btn',{class:[
					'white--text',
					'elevation-0',
					'animate__animated',
					_vm.slider.animations.control_right ],attrs:{"fab":"","color":"transparent"},on:{"click":function($event){return _vm.sliderChange(_vm.Next)}}},[_c('v-icon',[_vm._v(" mdi-chevron-double-right ")])],1)],1)]:_vm._e(),_c('v-row',[_c('v-col',{staticClass:"d-flex align-center justify-center",attrs:{"cols":"12","md":"5"}},[_c('div',{class:[
					'img-container',
					'animate__animated',
					_vm.slider.animations.imgContainer ]},[_c('img',{class:[
						'img',
						'animate__animated',
						_vm.slider.animations.img ],attrs:{"src":_vm.slider.img,"alt":""},on:{"click":function($event){return _vm.$router.push({
							name: 'Search',
							query: { categories: _vm.slider.categories },
						})}}})])]),_c('v-col',{class:[
				'd-flex',
				'flex-column',
				'justify-center',
				_vm.$vuetify.breakpoint.smAndDown ? 'pr-4' : 'pr-10' ],staticStyle:{"overflow":"hidden","position":"relative"},attrs:{"cols":"12","md":"7"}},[_c('div',{class:[
					'd-flex',
					'flex-column',
					_vm.$vuetify.breakpoint.smAndDown ? 'mb-1' : 'mb-10' ]},[_c('span',{class:[
						'sp-title',
						'animate__animated',
						_vm.slider.animations.title ]},[_vm._v(" "+_vm._s(_vm.slider.title)+" ")]),_c('span',{class:[
						'sp-name',
						'animate__animated',
						_vm.slider.animations.name,
						_vm.$vuetify.breakpoint.smAndDown ? 'ml-0' : 'ml-15' ]},[_vm._v(" "+_vm._s(_vm.slider.name)+" ")])]),_c('span',{class:[
					'title-desc',
					'animate__animated',
					_vm.slider.animations.desctitle ]},[_vm._v(" DESCRIPCIÓN: ")]),_c('p',{class:[
					'sp-description',
					'animate__animated',
					_vm.slider.animations.description,
					_vm.$vuetify.breakpoint.smAndDown
						? 'mt-1 ml-0'
						: 'mt-5 ml-13' ]},[_vm._v(" "+_vm._s(((_vm.slider.description) + " (TEXTO PARA FINES DE PRUEBA)"))+" ")]),_c('div',{class:[
					'd-flex',
					'mb-10',
					_vm.$vuetify.breakpoint.smAndDown
						? 'justify-center'
						: 'justify-end' ]},[_c('v-btn',{class:['animate__animated', _vm.slider.animations.button],attrs:{"large":"","color":"warning","block":_vm.$vuetify.breakpoint.smAndDown},on:{"click":function($event){return _vm.$router.push({
							name: 'PrductShow',
							params: { id: _vm.slider.product_id },
						})}}},[_vm._v(" ver producto ")])],1),(_vm.$vuetify.breakpoint.mdAndUp)?_c('div',{staticClass:"controls-container"},_vm._l((_vm.sliders),function(i,key){return _c('v-tooltip',{key:key,attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
						var on = ref.on;
						var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({class:[
								'control',
								{
									'control-active': _vm.sliderKey == key,
								} ],on:{"click":function($event){return _vm.sliderChange(key)}}},'div',attrs,false),on))]}}],null,true)},[_c('span',{staticStyle:{"text-transform":"uppercase"}},[_vm._v(" "+_vm._s(_vm.sliders[key].name)+" ")])])}),1):_vm._e()])],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }